import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import style from "./zoomPhoto.module.scss";
import { useEffect, useRef, useState } from "react";

export const ZoomPhoto = ({ image, title, loading, setLoading, showBottomBtn = true, showTopBtn, classes, containImage = false, fallbackImage }) => {
  const transformRef = useRef(null);
  const [imgSrc, setImgSrc] = useState(image);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (transformRef.current) {
      transformRef.current.resetTransform();
    }
  }, [image]);

  useEffect(() => {
    setImgSrc(image);
    setIsError(false);
  }, [image]);

  return (
    <div className={`d-flex justify-content-center align-items-center border shadow-md ${classes?.outerClass ? classes?.outerClass : "rounded"}`}>
      <TransformWrapper ref={transformRef} initialScale={1} minScale={1} maxScale={4} centerOnInit={true} limitToBounds={true}>
        {({ zoomIn, zoomOut, resetTransform }) => (
          <div className={classes?.innerClass ? classes?.innerClass : "position-relative w-100 mx-4 mt-4 mb-2"}>
            <TransformComponent
              wrapperClass="d-flex justify-content-center align-items-center w-100 h-100"
              contentClass="d-flex justify-content-center align-items-center w-100 h-100"
            >
              <div className={`w-100 position-relative ${style.zoom_photo}`}>
                <img
                  key={imgSrc}
                  loading="lazy"
                  src={imgSrc}
                  alt="zoomImage"
                  className={containImage ? "" : "w-100"}
                  onLoad={() => setLoading && setLoading(false)}
                  onError={() => {
                    setLoading && setLoading(false);
                    if (fallbackImage) setImgSrc(fallbackImage);
                    else setIsError(true);
                  }}
                  style={{
                    visibility: loading || isError ? "hidden" : "visible",
                    maxHeight: showBottomBtn ? "550px" : "100%",
                    borderRadius: showBottomBtn ? "12px" : undefined,
                    ...(containImage && { maxWidth: "100%", width: "auto", height: "auto", margin: "0 auto", display: "block" }),
                  }}
                />
                {loading && <div className={classes?.shimmerClass}><div className={style.skeleton_photo}></div></div>}
                {isError && !fallbackImage && <div className={classes?.shimmerClass} />}
              </div>
            </TransformComponent>

            {showBottomBtn && !loading && (
              <div className="d-flex align-items-center justify-content-between">
                <div className="flex-grow-1 text-center">
                  <div className="d-flex justify-content-center align-items-center">
                    <h5 style={{ fontSize: "18px" }}>{title}</h5>
                  </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                  <button data-testid="zoomInButton" className="btn btn-sm mr-2" onClick={() => zoomIn(0.2)}>
                    <i className="fa fa-search-plus fa-lg" aria-hidden="true"></i>
                  </button>
                  <button data-testid="zoomOutButton" className="btn btn-sm" onClick={() => zoomOut(0.2)}>
                    <i className="fa fa-search-minus fa-lg" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            )}
            {showTopBtn && !loading && (
              <div className={`${style.zoomIcon} d-flex align-items-center justify-content-around`}>
                <i
                  className={`${style.iconHover} fa fa-search-plus`}
                  style={{ color: "#fff", fontSize: "18px" }}
                  onClick={() => zoomIn(0.2)}
                  aria-hidden="true"
                  data-testid="zoomInAction"
                ></i>
                <i
                  className={`${style.iconHover} fa fa-search-minus`}
                  style={{ color: "#fff", fontSize: "18px" }}
                  onClick={() => zoomOut(0.2)}
                  aria-hidden="true"
                  data-testid="zoomOutAction"
                ></i>
                <i
                  className={`${style.iconHover} fa fa-arrows-alt`}
                  style={{ transform: `rotate(45deg) scale(1.1)`, color: "#fff", fontSize: "18px" }}
                  onClick={() => resetTransform()}
                  aria-hidden="true"
                  data-testid="reSizeAction"
                ></i>
              </div>
            )}
          </div>
        )}
      </TransformWrapper>
    </div>
  );
};
